import BaseFormPresenter from "../../../base/BaseFormPresenter";

class EmployeesFormPagePresenter extends BaseFormPresenter {
  constructor(view, getObjectUseCase, deleteObjectUseCase, upsertUseCase) {
    super(view, getObjectUseCase, deleteObjectUseCase, upsertUseCase);
    this.getObjectUseCase = getObjectUseCase;
    this.deleteObjectUseCase = deleteObjectUseCase;
    this.upsertUseCase = upsertUseCase;
  }

  async getObject() {
    const collection = this.view.getCollectionName();
    const id = this.object.id || this.view.getObjectId();
    if (id) {
      const params = {};
      try {
        this.view.showProgress();
        this.object = await this.getObjectUseCase.execute(collection, id, {
          params,
        });
        this.view.hideProgress();
        this.originalObject = JSON.parse(JSON.stringify(this.object));
        this.view.setObject(this.object);
      } catch (error) {
        this.view.hideProgress();
        this.view.showError(error);
      }
    }
  }

  async onSubmit(obj) {
    const user = this.view.getCurrentUser();
    const isAdmin = this.view.isAdmin();
    const clientId = this.view.getClientId();
    const collection = this.view.getCollectionName();

    let employeeObject = { ...obj };
    if (!obj?.id) {
      employeeObject.client = { id: isAdmin ? clientId : user.client?.id };
    }

    try {
      this.view.showProgress();

      const object = await this.upsertUseCase.execute(
        collection,
        employeeObject,
      );
      this.view.hideProgress();

      window.history.back();

      if (!employeeObject.id) {
        this.view.successModal("Submitted Successfully!");
      } else {
        this.view.successModal("Data Updated Successfully!");
      }
    } catch (error) {
      this.view.showError(error);
    }
  }
}

export default EmployeesFormPagePresenter;
